export class Search {
	static readonly type = '[lawyerSearch] search';
	constructor(
		public payload: {
			searchValue: string;
			lawFirmId?: string;
			cardId?: string;
			role?: string;
		},
	) {}
}
